// Application constants
export const APP_CONFIG = {
  title: '$PGC TO THE MOON! 🚀',
  subtitle: 'Limited-time airdrop🔥 Get your $PGC now. We\'re building a sustainable future by turning plastic waste into clean energy using',
  logoUrl: 'https://petgascoin.com/assets/images/logo_Big.png',
  adminEmail: 'contact@petgascoin.com',
};

// Form validation constants
export const VALIDATION_RULES = {
  name: {
    required: 'Name is required',
    minLength: { value: 2, message: 'Name must be at least 2 characters' },
    maxLength: { value: 50, message: 'Name must not exceed 50 characters' },
    pattern: { 
      value: /^[a-zA-Z\s]+$/, 
      message: 'Name can only contain letters and spaces' 
    }
  },
  email: {
    required: 'Email is required',
    pattern: { 
      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, 
      message: 'Please enter a valid email address' 
    }
  },
  walletAddress: {
    required: 'Wallet address is required',
    pattern: {
      value: /^0x[a-fA-F0-9]{40}$/,
      message: 'Please enter a valid BNB wallet address (0x followed by 40 hex characters)'
    }
  }
};

// Animation timing constants
export const ANIMATION_CONFIG = {
  titleWords: [
    '$PGC', 'TO', 'THE', 'MOON!', '🚀',
    'Limited-time', 'airdrop🔥', 'Get', 'your', '$PGC', 'now.',
    'We\'re', 'building', 'a', 'sustainable', 'future', 'by',
    'turning', 'plastic', 'waste', 'into', 'clean', 'energy', 'using'
  ],
  staggerDelay: 0.2, // seconds between each word animation
  logoRotationDuration: 10, // seconds for full logo rotation cycle
};

// Error messages
export const ERROR_MESSAGES = {
  DUPLICATE_EMAIL: 'This email is already registered for the whitelist.',
  DUPLICATE_WALLET: 'This wallet address is already registered for the whitelist.',
  DATABASE_ERROR: 'There was an error saving your information. Please try again.',
  EMAIL_SEND_ERROR: 'Your registration was saved but we couldn\'t send the confirmation email. Please contact support.',
  NETWORK_ERROR: 'Network error. Please check your connection and try again.',
  VALIDATION_ERROR: 'Please correct the errors below and try again.',
  UNKNOWN_ERROR: 'An unexpected error occurred. Please try again or contact support.',
  CONNECTION_TIMEOUT: 'The request timed out. Please check your connection and try again.',
  SERVER_UNAVAILABLE: 'The server is temporarily unavailable. Please try again in a few moments.',
  RATE_LIMITED: 'Too many requests. Please wait a moment before trying again.',
  INVALID_RESPONSE: 'Received an invalid response from the server. Please try again.',
  JAVASCRIPT_REQUIRED: 'JavaScript is required for this application to function properly.',
};

// User-friendly error messages for different scenarios
export const USER_ERROR_MESSAGES = {
  NETWORK_OFFLINE: {
    title: 'You\'re offline',
    message: 'Please check your internet connection and try again.',
    action: 'Retry when online'
  },
  NETWORK_SLOW: {
    title: 'Slow connection detected',
    message: 'Your connection seems slow. The form may take longer to submit.',
    action: 'Continue anyway'
  },
  FORM_VALIDATION: {
    title: 'Please check your information',
    message: 'Some fields need your attention before we can proceed.',
    action: 'Review form'
  },
  SUBMISSION_FAILED: {
    title: 'Registration failed',
    message: 'We couldn\'t complete your registration. Don\'t worry, you can try again.',
    action: 'Try again'
  },
  EMAIL_FAILED: {
    title: 'Registration successful',
    message: 'You\'re on the whitelist! However, we couldn\'t send your confirmation email.',
    action: 'Contact support'
  }
};

// Success messages
export const SUCCESS_MESSAGES = {
  REGISTRATION_SUCCESS: 'Congratulations! You\'ve been successfully added to the $PGC whitelist.',
  EMAIL_SENT: 'A confirmation email has been sent to your email address.',
};

// API endpoints and configuration
export const API_CONFIG = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL,
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY,
  adminEmail: import.meta.env.VITE_ADMIN_EMAIL || APP_CONFIG.adminEmail,
  logoUrl: import.meta.env.VITE_LOGO_URL || APP_CONFIG.logoUrl,
};

// Responsive breakpoints (matching Tailwind)
export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
};

// Logo sizes for different screen sizes
export const LOGO_SIZES = {
  small: { width: 140, height: 140 }, // mobile
  medium: { width: 180, height: 180 }, // tablet
  large: { width: 250, height: 250 }, // desktop
  xlarge: { width: 290, height: 290 }, // large desktop
};